import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorSectionFormatter = () => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    illustration: "errors/general",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiAddonCopilotPreview.components.copilotPreview.sections.errorSectionTitle"
    })
  });
};
export default ErrorSectionFormatter;